module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAcCAYAAAB75n/uAAAAAXNSR0IArs4c6QAAALxJREFUSInt1DsOxCAMRVF7dYhVBVaFLNZmeapEhPCxE+jm9dxTYQDDcs4HER2WN2iJi0gAABCR4JyLy4Ayfk6LTIFW3IIMgVFci3QBTVyDNAFLfIY8gDfxEXIDvsR7yAWsiLcQXB2vEdwRL5Ed3f9sQyIKiGi68doxc0QAgB0IM0fvfbg+2krkjANUp2IFUsYfwFekjjeBt0gr3gWsSC8+BLTIKD4FZsgsrgJ6iCauBmpEGzePiEJKyRT+AeKl2RCCi4k5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/sort-default.png
// module id = zOHx
// module chunks = 1